export default __webpack_public_path__ + "static/media/toy8.37428de7.jfif";